import React from "react";
import { useNavigate } from "react-router-dom";
import { Identifications } from "../../helpers/types";
import { FAN } from "../../helpers/constant";
import RightArrowIcon from "../../assets/icons/arrow-right-white.svg";
import IdentificationBorder from "../../assets/icons/identification-border.svg";
import "./index.less";

interface IdentificationComponentProps {
  identifications?: Identifications[];
  role?: string;
}

const IdentificationComponent: React.FC<IdentificationComponentProps> = ({ identifications, role }) => {
  const navigate = useNavigate();

  if (!identifications || identifications.length === 0) {
    return null;
  }

  if (identifications.length === 1) {
    return (
      <div className="identification-single">
        <div className="identification-profile-card">
          <img
            src={identifications[0].avatar}
            alt="Profile identification"
            onError={(e) => {
              e.currentTarget.src = "https://via.placeholder.com/300x400/cccccc/666666?text=Profile";
            }}
            onClick={() => navigate(`/p/${identifications[0].username}`)}
          />
          <div className={`identification-gradient-overlay ${role === FAN ? "fan-gradient" : "creator-gradient"}`}></div>
          <div className="identification-profile-info">
            <div
              className="identification-name-section"
              onClick={() => {
                navigate(`/p/${identifications[0].username}`);
              }}
            >
              <span className="identification-name">{identifications[0].username}</span>
              <span className="identification-label">(Identification)</span>
            </div>
            <img className="identification-arrow" src={RightArrowIcon}></img>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="identification-multiple">
      {identifications.map((identification, index) => (
        <div
          key={identification.id}
          className="identification-story-ring"
          style={{
            zIndex: identifications.length - index,
            marginLeft: index > 0 ? "-12px" : "0",
          }}
        >
          <div className="identification-story-avatar">
            <img className="identification-border-svg" src={IdentificationBorder} alt="" />
            <img
              className="identification-avatar-img"
              src={identification.avatar}
              alt={`User ${index + 1}`}
              onError={(e) => {
                e.currentTarget.src = "https://via.placeholder.com/64x64/cccccc/666666?text=U";
              }}
              onClick={() => {
                navigate(`/p/${identification.username}`);
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default IdentificationComponent;
